import { IonText } from '@ionic/react';
import { ReactElement } from 'react';
import i18n from '../../../i18n';

const ScratchpadNoParts = (): ReactElement => {
  return (
    <div className="full-height-width content-center">
      <IonText className="ion-padding ion-text-center" color="medium">
        <div>
          <h2>{i18n.t('common:scratchpad_create_first_part')}</h2>
          <p>{i18n.t('common:scratchpad_create_first_part_description')}</p>
        </div>
      </IonText>
    </div>
  );
};

export { ScratchpadNoParts };
